import { render, staticRenderFns } from "./tradeList.vue?vue&type=template&id=6430c54c&scoped=true"
import script from "./tradeList.vue?vue&type=script&lang=js"
export * from "./tradeList.vue?vue&type=script&lang=js"
import style0 from "./tradeList.vue?vue&type=style&index=0&id=6430c54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6430c54c",
  null
  
)

export default component.exports